const centerIdToHide = 1 // UF SAS

function displayCenterName(centerId, centerName) {
    return +centerId === centerIdToHide ? '' : centerName
}

export { displayCenterName }
